var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadTuneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 207,
    viewBox: "0 0 207 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.833 0.583328H62.3333C50.961 0.583328 41.75 9.79437 41.75 21.1667V144.667C41.75 156.039 50.961 165.25 62.3333 165.25H185.833C197.206 165.25 206.417 156.039 206.417 144.667V21.1667C206.417 9.79437 197.206 0.583328 185.833 0.583328ZM165.25 52.0417H134.375V108.646C134.375 122.848 122.848 134.375 108.646 134.375C94.4433 134.375 82.9167 122.848 82.9167 108.646C82.9167 94.4433 94.4433 82.9167 108.646 82.9167C114.461 82.9167 119.761 84.9235 124.083 88.1654V31.4583H165.25V52.0417ZM21.1667 41.75H0.583336V185.833C0.583336 197.206 9.79438 206.417 21.1667 206.417H165.25V185.833H21.1667V41.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadTuneIcon);
export default __webpack_public_path__ + "static/media/upload-tune-icon.49894f4b.svg";
export { ForwardRef as ReactComponent };